/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ScheduleQueryResult from './ScheduleQueryResult';

/**
 * The ScheduleOutputCmsSchedules model module.
 * @module model/ScheduleOutputCmsSchedules
 * @version 1.0
 */
class ScheduleOutputCmsSchedules {
    /**
     * Constructs a new <code>ScheduleOutputCmsSchedules</code>.
     * @alias module:model/ScheduleOutputCmsSchedules
     */
    constructor() { 
        
        ScheduleOutputCmsSchedules.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScheduleOutputCmsSchedules</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduleOutputCmsSchedules} obj Optional instance to populate.
     * @return {module:model/ScheduleOutputCmsSchedules} The populated <code>ScheduleOutputCmsSchedules</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduleOutputCmsSchedules();

            if (data.hasOwnProperty('schedules')) {
                obj['schedules'] = ApiClient.convertToType(data['schedules'], [ScheduleQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/ScheduleQueryResult>} schedules
 */
ScheduleOutputCmsSchedules.prototype['schedules'] = undefined;






export default ScheduleOutputCmsSchedules;

